import { render } from "./statsRefs.vue?vue&type=template&id=690cc962&scoped=true"
import script from "./statsRefs.vue?vue&type=script&lang=js"
export * from "./statsRefs.vue?vue&type=script&lang=js"

import "./statsRefs.vue?vue&type=style&index=0&id=690cc962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690cc962"]])

export default __exports__